// extracted by mini-css-extract-plugin
export var active = "_24-9";
export var backButton = "_24-8";
export var clone = "_24-e";
export var collapseBar = "_24-k";
export var collapseMode = "_24-m";
export var collapsed = "_24-o";
export var dimmed = "_24-i";
export var dragHandle = "_24-c";
export var dropdownIcon = "_24-g";
export var expanding = "_24-n";
export var hidden = "_24-x";
export var iconContainer = "_24-q";
export var iconSwapper = "_24-w";
export var navItem = "_24-6";
export var navItemIcon = "_24-f";
export var navProfile = "_24-7";
export var notificationCountBadge = "_24-j";
export var notificationDot = "_24-r";
export var optionsContainer = "_24-h";
export var primaryNav = "_24-0";
export var primaryNavDivider = "_24-v";
export var primaryNavResizeHandle = "_24-2";
export var primaryNavResizing = "_24-1";
export var primaryNavTabSection = "_24-u";
export var primaryTab = "_24-p";
export var primaryTabIconBox = "_24-s";
export var secondaryNav = "_24-3";
export var selected = "_24-t";
export var settingsNav = "_24-4";
export var settingsNavItems = "_24-5";
export var show = "_24-d";
export var sideNav = "_24-l";
export var teamItem = "_24-a";
export var userProfileItem = "_24-b";